import { hillo } from 'hillo'
import IKDataEntity from '@/plugins/EntityFrameWork/IKDataEntity'
import { getCurrentDeviceId } from '@/model/dataLayer/service/RestaurantInfoService'
import { cloudV2Url } from '@/model/dataLayer/api/SaaS/SaaSUtils'

const businessPath = 'common/businessLayer'

const entity = {
  id: {},
  type: {},
  deviceId: {},
  name: {}
}
const config = {
  load: async function () {
    const res = (await hillo.get(cloudV2Url + businessPath + '/assureShop/' + await getCurrentDeviceId()))
    res.name = res.displayInfo.name
    return res
  }
}

export default IKDataEntity.ModelFactory(entity, config)

export async function getBusinessLayer (deviceId) {
  const res = (await hillo.get(cloudV2Url + businessPath + '/assureShop/' + deviceId))
  res.name = res.displayInfo.name
  return res
}

export async function getBusinessLayerByBlId (blId) {
  return (await hillo.get(cloudV2Url + businessPath + '/' + blId))
}

/**
 * 门店已加入品牌时返回品牌名，独立门店返回 ''（查不到也按独立门店处理）。
 * 一店一个会员体系：加入品牌后会员相关配置由品牌在会员后台 member.aaden.io 统一管理。
 */
export async function getJoinedBrandName (blId) {
  try {
    const shop = await getBusinessLayerByBlId(blId)
    if (!shop?.parentId) return ''
    const brand = await getBusinessLayerByBlId(shop.parentId)
    return brand?.displayInfo?.name || '品牌'
  } catch (e) {
    return ''
  }
}

export async function bindStore (userId, blId) {
  return (await hillo.jsonPost(cloudV2Url + 'user-bl/bind', {}, {
    params: { userId, blId }
  }))
}

export async function getAllBusinessLayer () {
  const allList = (await hillo.get(cloudV2Url + businessPath + '/all', {}))
  allList.forEach(it => {
    it.color = it.displayInfo.color
    it.name = it.displayInfo.name ? it.displayInfo.name : it.deviceId
    it.description = it.displayInfo.description
    it.parentDisplay = allList.find(x => x.id === it.parentId)?.displayInfo.name ?? ''
    return it
  })
  return allList
}

export const BLTyp = {
  Brand: 'Brand',
  Normal: 'Normal',
  Shop: 'Shop'
}

export async function updateBusinessLayerParent (item) {
  return (await hillo.jsonPost(cloudV2Url + businessPath + '/updateParent', {
    ...item
  }))
}
